/* eslint-disable no-nested-ternary */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

export default function CapitalText({ text }) {
    if (!text) return ' ';

    return <Fragment>{text[0].toUpperCase() + text.slice(1, text.length)}</Fragment>;
}

CapitalText.propTypes = {
    text: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/helpers/CapitalText.jsx